<template>
  <tippy :to="to"
         theme="default default-main-menu" 
         interactive 
         animation="fade" 
         arrow 
         arrow-type="round"
         placement="bottom-start"
         :delay="[0, 0]"
         :max-width="undefined"
         trigger="click"
  >
    <template #default>
      <DropdownMenuContent class="no-start-border"
                           :items="items"
                           :key-tag="keyTag"
                           :key-children="keyChildren"
                           :key-text="keyText"
                           :key-divider="keyDivider"
                           :key-href="keyHref"
                           :key-is-local-url="keyIsLocalUrl"/>
    </template>
  </tippy>
</template>

<script>
import DropdownMenuContent from "./DropdownMenuContentDesktop.vue";

export default {
  inheritAttrs: false,
  components: {
    DropdownMenuContent,
  },
  props: {
    to: {type: String, required: true},
    items: Array,
    keyTag: String,
    keyChildren: String,
    keyText: String,
    keyDivider: String,
    keyHref: String,
    keyIsLocalUrl: String,
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>

<style lang="scss" scoped>

.dropdown-menu-2.no-start-border {
  border-inline-start: none;
  padding-inline-start: 0;
}

</style>
